import { type DefaultQueryError, httpClient } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { DefaultOpsTechResponse } from '../types';
import type { MyReward } from './types';
import type { GetRewardParams } from './use-get-reward';
import apiRoutes from '@/lib/api-routes';

export type GetMyRewardDetailParams = Pick<
  GetRewardParams,
  'category_id' | 'type'
> & { id: number };

export const getMyRewardDetailFn = async ({
  id,
  ...params
}: GetMyRewardDetailParams) => {
  const response = await httpClient.get<DefaultOpsTechResponse<MyReward>>(
    apiRoutes.rewards.myRewardDetail(id),
    {
      params,
    }
  );
  return response.data.data;
};

export const useGetMyRewardDetail = (
  { id, ...params }: GetMyRewardDetailParams,
  opts?: UseQueryOptions<MyReward, DefaultQueryError>
) =>
  useQuery<MyReward, DefaultQueryError>({
    queryKey: [apiRoutes.rewards.myRewardDetail(id), params],
    queryFn: () => getMyRewardDetailFn({ id, ...params }),
    ...opts,
  });
